<template>
<div style="width: 100%;">
  <el-tooltip popper-class="heatmap" placement="bottom" v-for="item in tableDatas" :key="item.objId">
    <div slot="content" v-if="item.objDefineId === 'FMS_SENSOR'">
      <p><span>1. 센서명 | </span><span>{{ getValueAfterCheckEmpty(item.objName) }}</span></p>
      <p><span>2. 수집 방식 | </span><span>{{ getValueAfterCheckEmpty(item.rscGetmethodId) }}</span></p>
      <p><span>3. IP | </span><span>{{ getValueAfterCheckEmpty(item.ipaddress) }}</span></p>
      <p><span>4. 포트 | </span><span>{{ getValueAfterCheckEmpty(item.snmpPort) }}</span></p>
    </div>
    <div slot="content" v-else-if="item.objDefineId === 'E2E_SERVICE'">
      <p><span>1. E2E 서비스명 | </span><span>{{ getValueAfterCheckEmpty(item.serviceName) }}</span></p>
      <p><span>2. URL | </span><span>{{ getValueAfterCheckEmpty(item.serviceUrl) }}</span></p>
      <p><span>3. 프로토콜명 | </span><span>{{ getValueAfterCheckEmpty(item.protocol) }}</span></p>
    </div>
    <div slot="content" v-else-if="item.objDefineId === 'SERVICE'">
      <p><span>1. 서비스명 | </span><span>{{ getValueAfterCheckEmpty(item.objName) }}</span></p>
      <p><span>2. 운영 상태 | </span><span>{{ getResourceCount(item.eventCount) }}</span></p>
      <p><span>3. 관련 자원 수 | </span><span>{{ getValueAfterCheckEmpty(item.elementCount) }}</span></p>
    </div>
    <div slot="content" v-else>
      <p><span>1. 장비명 | </span><span>{{ getValueAfterCheckEmpty(item.objName) }}</span></p>
      <p><span>2. IP | </span><span>{{ getValueAfterCheckEmpty(item.ipaddress) }}</span></p>
      <p><span>3. 장비 타입 | </span><span>{{ getValueAfterCheckEmpty(item.objtypeName) }}</span></p>
      <p v-if="item.objDefineId !== 'WAS'">
        <span>4. 벤더 | </span><span>{{ getValueAfterCheckEmpty(item.objCompanyName) }}</span>
      </p>
    </div>
    <!-- add margin 0103 -->
    <el-button style="margin-bottom:2px" class="node-small" :style="getHeatmapStyle(item)" @click="selectNode(item)"></el-button>
  </el-tooltip>
</div>
</template>

<script>
import commonAPI from '@/api/performance/common';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';
import { mapGetters } from 'vuex';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { isNil, isEmpty, isEqual } from 'lodash';

export default {
  name: 'WHeatmap',
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      tableDatas: [],
    };
  },
  computed: mapGetters(['selectedNode', 'selectedObjDefineIds', 'selectedObjDefineIdsForPhysical']),
  watch: {
    selectedNode: {
      handler() {
        this.loadStore();
      },
      immediate: true,
    },
    selectedObjDefineIds: {
      handler() {
        this.loadStore();
      },
    },
    selectedObjDefineIdsForPhysical: {
      handler() {
        this.loadStore();
      },
    },
    active: {
      handler() {
        this.loadStore();
      },
    },
  },
  methods: {
    loadStore() {
      if (this.active) {
        const treeType = this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
        const params = {
          treeType,
          subType: this.selectedNode.subType,
          managetypeId: this.selectedNode.managetypeId,
          objtypeId: this.selectedNode.objtypeId,
          objCompanyId: this.selectedNode.objCompanyId,
          managegroupIds: this.selectedNode.childManagegroupIds,
          objDefineIds: this.selectedObjDefineIds,
        };
        if (!isEmpty(this.selectedObjDefineIdsForPhysical)) {
          if (isEqual(this.selectedNode.managetypeId, 'NMS')) {
            params.objCompanyIds = this.selectedObjDefineIdsForPhysical;
          } else {
            params.objtypeIds = this.selectedObjDefineIdsForPhysical;
          }
        }
        commonAPI.getGroupHeatmapList(params).then((result) => {
          if (result.data.success === true) {
            this.tableDatas = result.data.data;
          }
        });
      }
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getValueAfterCheckEmpty(value) {
      return getValueAfterCheckEmpty(value);
    },
    getResourceCount(value) {
      if (isNil(value)) return EMPTY_TEXT;
      return value > 0 ? '비정상' : '정상';
    },
    /**
     * 선택한 장비에 대한 성능운영 화면으로 이동한다.
     * @author Ju
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    selectNode(data) {
      if (!isNil(data.objId)) {
        routePathByObjId(this, data.objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, this.selectedNode.childManagegroupIds);
      }
    },
    /**
     * 히트맵에 대한 스타일을 반환한다.
     * 발생한 이벤트가 있을 경우 가장 등급이 높은 이벤트 색상을 적용한다.
     * @author Ju
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    getHeatmapStyle(data) {
      if (data.eventCount > 0) {
        return {
          backgroundColor: data.eventlevelColorBg,
          color: data.eventlevelColorText,
          border: 0,
        };
      }
      return null;
    },
  },
};
</script>

<style>
.square {
  display: inline-block;
  width: 50px;
  height: 50px;
  background-color: #d1d7dd;
  margin: 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/performance/group/perfinfo/components/Heatmap.vue